import { initializeApp, getApps, getApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, OAuthProvider, setPersistence, browserLocalPersistence } from 'firebase/auth'
import { initializeFirestore, memoryLocalCache } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

// Public web config for the `lowgirecipes-5dd6e` Firebase project (public by
// design) — `firebase apps:sdkconfig WEB` for app "Glycemic Snap Web".
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyCsKLO0mJ_G20Fw2v5M6c89sIEL6GUSz1s',
  authDomain: 'lowgirecipes-5dd6e.firebaseapp.com',
  projectId: 'lowgirecipes-5dd6e',
  storageBucket: 'lowgirecipes-5dd6e.firebasestorage.app',
  messagingSenderId: '384279219589',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:384279219589:web:2592af1fd3b1d6e39108ec',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || 'G-25WTFNT0G9',
}

export const app = getApps().length ? getApp() : initializeApp(firebaseConfig)

export const auth = getAuth(app)

// In-memory cache only: the web companion is online-only and runs on shared
// computers, so no health data is written to IndexedDB (nothing to scrub on
// sign-out, nothing another tab can keep alive). ignoreUndefinedProperties
// matches the mobile writers' strip-undefined behavior — analyses carry
// optional keys.
export const db = initializeFirestore(app, {
  localCache: memoryLocalCache(),
  ignoreUndefinedProperties: true,
})

export const functions = getFunctions(app)
export const storage = getStorage(app)

void setPersistence(auth, browserLocalPersistence).catch(() => {
  /* falls back to in-memory if storage is unavailable */
})

export const googleProvider = new GoogleAuthProvider()

export const appleProvider = new OAuthProvider('apple.com')
appleProvider.addScope('email')
appleProvider.addScope('name')
